import { render, staticRenderFns } from "./FinishResetPassword.vue?vue&type=template&id=04292138"
import script from "./FinishResetPassword.vue?vue&type=script&lang=js"
export * from "./FinishResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports